// extracted by mini-css-extract-plugin
export default {"SearchBtn":"DocumentSpaceActionRow_SearchBtn__mJBTW"};